import { Fragment } from "react/jsx-runtime";
import { Input } from "reactstrap";
import { ChatMessage, ChatTitle, Href } from "../../../../../Constants/Constants";
import { ChatBackupData, ChatData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setChatWallpaper } from "../../../../../ReduxToolkit/Reducers/TemplateCustomizerReducers";
import { dynamicImage, Image } from "../../../../../Utils";
import CommonMediaHeading from "./Common/CommonMediaHeading";

const Chat = () => {
  const { settingsActiveTab } = useAppSelector((state) => state.mainSidebar);
  const { chatWallpaper } = useAppSelector((state) => state.templateCustomizer);
  const dispatch = useAppDispatch();
  return (
    <div className="setting-block">
      <div className={`block ${settingsActiveTab === "chat" ? "open" : ""}`}>
        <CommonMediaHeading title={ChatTitle} />
        <ul className="help">
          <li>
            <span>Chat Backup</span>
            <ul className="switch-list">
              {ChatBackupData.map((item, index) => (
                <li key={index}>
                  <div className="media-right form-switch">
                    <Input type="checkbox" defaultChecked={item.checked} />
                  </div>
                  <h5>{item.title}</h5>
                </li>
              ))}
            </ul>
          </li>
          <li>
            <span>Chat wallpaper</span>
            <ul className="wallpaper d-flex gap-2">
              {chatWallpaper.map((item, index) => (
                <Fragment key={index}>
                  {item.wallpaperImage && (
                    <li className={`${item.class} ${item.active ? "active" : ""}`} style={{ backgroundImage: `url(${dynamicImage(`wallpaper/${item.wallpaperImage}.jpg`)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }} onClick={() => dispatch(setChatWallpaper(item))}>
                      <Image className="bg-img" src={dynamicImage(`wallpaper/${item.wallpaperImage}.jpg`)} alt="Avatar" style={{ display: "none" }} />
                    </li>
                  )}
                </Fragment>
              ))}
            </ul>
          </li>
          {ChatData.map((item, index) => (
            <li key={index}>
              <h5>
                <a href={Href} className={item.class}>
                  {item.title}
                </a>
              </h5>
            </li>
          ))}
        </ul>
      </div>
      <CommonMediaHeading title={ChatTitle} text={ChatMessage} type="chat" />
    </div>
  );
};

export default Chat;
